import { createContext, useContext } from "react";

import type { AuthShellVariant } from "./auth-shell";

const AuthShellContext = createContext<AuthShellVariant>("classic");

/** Set by AuthLayout to the chrome it wears. */
export const AuthShellProvider = AuthShellContext.Provider;

/** The chrome of the AuthLayout around this screen, so its content lines up
 * with the heading: centered under the classic one, flush left under the
 * quote-flow one. Classic outside an AuthLayout. */
export function useEnclosingAuthShell(): AuthShellVariant {
  return useContext(AuthShellContext);
}
